import React from 'react'

import Project from "../../model2/project/project"
import ProjectIconUI5 from "../icons/project/project-icon-ui5"
import ProjectSession from "../../model2/project/project-session";

type Props = {
    className?                      : string

    companyId?                      : ID
    projectId?                      : ID | null
    currentProject                  : ID | null

    // Off by default -- Home is otherwise shown only once `currentProject` is
    // set, same as before this existed. Only the entity selector's Task Browse
    // opts in, to name the root "Home" instead of hiding the row there; every
    // other host keeps today's exact behavior.
    showHomeAtRoot?                 : boolean

    maxParents?                     : number

    style?                          : any
    type                            : 'default' | 'v2' | 'v3' | 'v4' | 'v5'
    coloredIcon                     : boolean

    handleRootNavigate              : boolean
    showRootProject                 : boolean
    currentProjectAsLastBreadcrumb  : boolean
    renderLastProjectAsColorPill    : boolean

    onNavigateProject?              : func
    onNavigateCompany?              : func
}

export default class Breadcrumbs extends React.Component<Props> {

    static defaultProps = {
        type                            : 'default',
        coloredIcon                     : false,
        handleRootNavigate              : false,
        showRootProject                 : true,
        currentProjectAsLastBreadcrumb  : false,
        renderLastProjectAsColorPill    : false
    }

    onNavigateProject = (id: ID) => {
        if (id === this.props.currentProject && !this.props.handleRootNavigate) return;
        if (this.props.onNavigateProject) this.props.onNavigateProject(id)
    }

    onNavigateCompany(id: ID) {
        if (this.props.onNavigateCompany) this.props.onNavigateCompany(id)
    }

    renderLastProject(pId: ID, project: ProjectSession) {
        let classes = Classes("breadcrumb-item breadcrumb-root-item", {
            ['gd-c-'+project.color]: this.props.renderLastProjectAsColorPill
        })

        return (
            <div key={pId} className={classes} onClick={this.onNavigateProject.bind(this, project.id)}>
                <ProjectIconUI5 className   = "breadcrumb-project-icon"
                                project     = {project}
                                colorize    = {!this.props.renderLastProjectAsColorPill ? this.props.coloredIcon : false}
                                hint        = {false}/>
                {project.name}
            </div>
        )
    }

    render() {
        let breadcrumbs         = []
        let exceedMaxParents    = false

        if (this.props.projectId !== this.props.currentProject) {
            // @ts-ignore
            const parentProjects = this.props.currentProject ? [this.props.currentProject].concat(gd.session.projects.getAllParents(this.props.currentProject).map((p: Project)=>p.id).reverse()) : []

            // previous parents retrieval method
            // const parentProjects = this.props.currentProject ? gd.tree.findProjectParents(gd.tree.getProject(this.props.currentProject)).map(p=>p.id).concat([this.props.currentProject]).reverse() : []

            let breadcrumbsCollected = false
            parentProjects.map(pId=>{
                if(!breadcrumbsCollected) {
                    const project = pId === 'projects' ? gd.spaces.projects.project : gd.session.projects.get(pId)
                    if (!project) return

                    if (this.props.projectId === pId) breadcrumbsCollected = true

                    if (pId === this.props.currentProject && !this.props.currentProjectAsLastBreadcrumb) {
                        if (!this.props.showRootProject) return;
                        breadcrumbs.unshift(this.renderLastProject(pId, project));
                    } else {
                        if (!this.props.maxParents || breadcrumbs.length < this.props.maxParents) {
                            breadcrumbs.unshift(
                                <div key={pId}
                                     className="breadcrumb-item"
                                     onClick={this.onNavigateProject.bind(this, project.id)}>
                                    {project.name}
                                    <div className="breadcrumb-item-separator i5-big-angle-right"/>
                                </div>
                            )
                        }

                        exceedMaxParents = !!this.props.maxParents && breadcrumbs.length >= this.props.maxParents
                    }
                }
            })

            // A project with no parent and no workspace lives directly under
            // the generic "Projects" space rather than a company workspace --
            // that space is never part of the parentId chain, so it has to be
            // added explicitly or the trail loses all trace of it.
            const rootProjectId = parentProjects[parentProjects.length - 1]
            const rootProject   = rootProjectId && rootProjectId !== 'projects' ? gd.session.projects.get(rootProjectId) : null

            if (rootProject && !rootProject.isWorkspace) {
                breadcrumbs.unshift(
                    <div key        = {'projects'}
                         className  = "breadcrumb-item"
                         onClick    = {this.onNavigateProject.bind(this, 'projects')}
                    >
                        {gd.spaces.projects.project.name}
                        <div className="breadcrumb-item-separator i5-big-angle-right"/>
                    </div>
                )
            }
        }

        // Home -- the breadcrumb trail's own root. Normally shown only once
        // there is a project underneath it, same as a project step; with
        // `showHomeAtRoot`, shown regardless, labelled "Home" when there isn't
        // one (otherwise it is an icon like every other step).
        if (this.props.companyId && (this.props.currentProject || this.props.showHomeAtRoot)) {
            breadcrumbs.unshift(
                <div key        = {this.props.companyId}
                     className  = "breadcrumb-item company"
                     onClick    = {this.onNavigateCompany.bind(this, this.props.companyId)}
                >
                    <div className="flex-row-left-center h-100p">
                        <span className="ui5-ico-16 action ii5-home"/>
                        {!this.props.currentProject &&
                            <span className="breadcrumb-home-label">Home</span>
                        }
                        <div className="breadcrumb-item-separator i5-big-angle-right"/>
                    </div>
                </div>
            )
        }

        const classes = Classes("gd-breadcrumbs-block", this.props.type+"-type", "breadcrumbs-"+breadcrumbs.length, this.props.className, {
            "exceed-max-parents": exceedMaxParents,
            "empty"             : breadcrumbs.length <= 0
        })

        return <div className={classes} style={this.props.style}>{breadcrumbs}</div>
    }
}